module.exports = __webpack_public_path__ + "components/advertise-contact/static/premium-incentive-background-50879cdb061a58557aefcfe6d0e628d9.jpg";